import React from "react";
import "./style.css";
const Success = () => {
   return (
      <div className="registered-from form-sec">
         <p className="form-heading">Request registered!</p>
         <p className="registered-text">
            Your request has been registered. Our concerned team member will
            contact you within 24-48 hours to confirm your access rights & set up
            the account. For any doubts, you may write to us at{" "}
            <a href="mailto:info@kid-ex.com">info@kid-ex.com</a>
         </p>
         <a href="https://kid-ex.com/champions/leaderboard" target="_blank" className="btn purple-button">View Leaderboard</a>
      </div>
   );
};

export default Success;
